<template>
  <a-layout-sider
    class="menus-sider"
    theme="light"
    :trigger="null"
    :collapsedWidth="40"
    :width="208"
    v-model="collapsed"
    v-if="meunList.length"
  >
    <div style="flex: 1 1 0%; overflow: hidden auto;">
    <a-menu
      mode="inline"
      theme="light"
      :openKeys.sync="openKeys"
      :selected-keys="isUrl"
      @click="handleClick"
      :inline-collapsed="collapsed"
    >
      <a-menu-item v-for="(item, index) in meunList" :key="index" @click="verification(item.menuUrl, index)">
        <icon-font :type="item.menuIcon"></icon-font>
        <span>{{ item['menu' + languageCodes[currentLang] + 'Name'] }}</span>
      </a-menu-item>
    </a-menu>
    </div>
    <div class="menus-collapsed" @click="collapsed = !collapsed">
      <svg-icon iconfont :name="collapsed ? 'open-icon-zhankai' : 'open-icon-shouqi'" style="font-size:16px;"></svg-icon>
      <span style="margin-left: 5px" class="ant-menu-title-content" v-show="!collapsed">{{$t('common_conj_put')}}</span>
    </div>
  </a-layout-sider>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { openNotificationWithIcon } from '@/utils/util'

export default {
  data () {
    return {
      collapsed: false,
      languageCodes: this.$root.languageCodes({ 'zh_CN': '' }),
      searchValue: '',
      rootSubmenuKeys: ['sub1', 'sub2', 'sub4'],
      openKeys: ['sub1']
      // testLink: ''
    }
  },
  computed: {
    ...mapState({
      currentLang: state => state.isLogin.lang,
      'meunList': state => state.isLogin.meunList,
      'meunIsLoading': state => state.isLogin.meunIsLoading,
      toOtherMenu: state => state.isLogin.toOtherMenu
    }),
    ...mapGetters(['personalData']),
    isUrl () {
      const { path } = this.$route
      let pathMap = this.meunList.map((item) => item.menuUrl)
      let index = pathMap.indexOf(path.replace(/^(\/work\/[a-zA-Z]+)(\/.*?)$/, '$1'))
      return index === -1 ? [] : [index]
    }
  },
  mounted () {
    // this.$nextTick(() => {
    //   if (this.personalData?.isConfirm === 0) { // 未审核
    //     this.testLink = '/work/credentials'
    //   } else { // 已审核
    //   }
    // })
  },
  methods: {
    verification (url, index) {
      if (this.$route.name === 'Credentials' && !this.toOtherMenu) { // 未审核或不通过无法跳转其他页面
        this.$router.push('/work/credentials')
        if (index !== 0) {
          openNotificationWithIcon(this.$t('credentials_使用平台前请完成企业信息认证流程'))
        }
        return false
      }
      this.$router.push(url)
    },
    handleClick (e) {
      // console.log('click', e)
    }
  }
}
</script>

<style lang="less" scoped>
.menus-sider {
  height: calc(100vh - 64px);
  background: #fff !important;
  text-align: left;
  .ant-menu {
    border: none;
  }
  .ant-menu-item .anticon {
    font-size: 16px;
  }
  .ant-menu-item::after {
    right: auto;
    left: 0;
  }
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: transparent;
  }
  .ant-menu-item-selected {
    background: linear-gradient(270deg, rgba(17, 178, 254, 0) 0%, rgba(7, 123, 252, 0.06) 100%);
  }
  .menu-icon {
    margin-right: 8px;
  }
  .menus-collapsed {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 36px;
    box-shadow: 0px -1px 2px 0px rgba(152, 161, 171, 0.17);
    display: flex;
    align-items: center;
    padding-left: 16px;
    color: rgba(0, 0, 0, 0.65);
    cursor: pointer;
    &:hover {
      box-shadow: 0px -1px 10px 0px rgba(152, 161, 171, 0.37);
    }
  }
  .ant-menu-inline-collapsed > .ant-menu-item {
    padding: 0 14px !important;
    max-width: 40px;
    &-selected::after {
      transform: none;
      opacity: 1;
    }
  }
  &.ant-layout-sider-collapsed .menus-collapsed {
    padding-left: 10px;
  }
}
</style>
